var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7593 18.0001H27.172V15.3794C25.9054 15.3794 24.8795 14.3536 24.8795 13.087C24.8795 11.8203 25.9054 10.7945 27.172 10.7945V8.17383H7.51953V10.7945C8.78615 10.7945 9.81202 11.8203 9.81202 13.087C9.81202 14.3536 8.78615 15.3794 7.51953 15.3794V18.0001H12.7608H12.7593Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6525 8.17034C19.3874 8.21174 18.36 7.17974 18.36 5.91312C18.36 4.64651 19.3859 3.62064 20.6525 3.62064V1H1V3.62064C2.26662 3.62064 3.29248 4.64651 3.29248 5.91312C3.29248 7.17974 2.26662 8.20561 1 8.20561V10.8262H7.5907",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8633 8.17188V17.9974",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73047 1V10.8255",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponsInactive);
export default __webpack_public_path__ + "static/media/coupons-inactive.93d7d7369aa947acef739968670d90ea.svg";
export { ForwardRef as ReactComponent };